module.exports = __webpack_public_path__ + "img/menu0.6c9a91da.png";